export default "__VITE_ASSET__CR3hByk7__"